<template>
    <div class="models-container">
        <div class="loading-mask" v-loading="ui.isLoadingHistory" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-if="ui.isLoadingHistory" />
        <LeftMenu :show="ui.showLeftMenu" :typing="ui.typing" :tabs="['promptTemplateHistory']" :tabName="'promptTemplateHistory'" :historyMap="historyMap"
            @goBack="goto('/call');" />
        <div v-if="currentModel && currentTemplate" class="right-content">
            <!-- 提示词测试 -->
            <div class="template-flex-wrapper-top">
                <el-link type="primary" :underline="false" @click="currentTemplate = null">
                    <img src="@/theme/images/knowledge/icon-arrow-back.svg">
                    <span>返回助手库</span>
                </el-link>
                &nbsp;&nbsp;&nbsp;
                {{currentModel.title}}
                》
                {{currentTemplate.name}}
            </div>
            <div class="template-flex-wrapper-main">
                <div class="template-flex-wrapper-left">
                    <div class="viewer-editor">
                        <gpt-editor-promptTemplate :model="currentModel" :promptTemplate="currentTemplate" @input="prompt = $event" />
                    </div>
                    <div v-show="!showTemplateEditor" class="template-editor__open" @click="showTemplateEditor = true">
                        <div class="template-editor__open-img"></div>
                    </div>
                </div>
                <div v-show="showTemplateEditor" class="template-flex-wrapper-right">
                    <div class="msg-box-flex-wrapper">
                        <MsgBoxScroll>
                            <template v-for="(msg, index) in currentChat.messages">
                                <MsgUserAsk v-if="msg.role === 'user'" :key="index" :ref="`msg${index}`" :data="msg" @askAgain="prompt = $event" />
                                <MsgChatRespondThink v-else-if="msg.role === 'think'" :key="index" :ref="`msg${index}`" :data="msg" @thinkSocketFinish="thinkSocketFinish" />
                                <MsgChatRespond v-else-if="msg.role === 'assistant'" :key="index" :ref="`msg${index}`" :askData="currentChat.messages[index-1]" :data="msg" />
                                <div v-else :key="index">{{msg.content}}</div>
                            </template>
                        </MsgBoxScroll>
                    </div>
                    <div class="input-box-flex-wrapper">
                        <div class="input-placeholder"></div>
                        <gpt-chatbox :class="[(ui.typing ? 'typing' : '')]" v-if="modelListCommon.length" v-loading="ui.isSocketReconnecting" element-loading-text="会话连接中..."
                            :modelList="modelListCommon" :input.sync="prompt" :model.sync="model" :typing="ui.typing" :simpleChatBox="true"
                            @commonAsk="templateAsk">
                        </gpt-chatbox>
                        <div class="input-placeholder"></div>
                        <div class="float-buttons">
                            <el-link type="primary" @click="showTemplateValueMap = !showTemplateValueMap">提示词变量</el-link>
                        </div>
                        <div class="float-buttons right">
                            <el-link type="primary" @click="showModelSettings = !showModelSettings">参数调节</el-link>
                        </div>
                        <gpt-editor-modelSettings v-if="currentModel" v-show="showModelSettings" :value.sync="currentModel.modelSettings" />
                        <gpt-editor-templateValueMap v-if="currentTemplate" v-show="showTemplateValueMap" :value.sync="templateValueMap" :promptTemplate="currentTemplate" />
                        <ExportSessionBox :visible.sync="showExportSession" :sessionId="currentSessionId" />
                    </div>
                    <div v-show="showTemplateEditor" class="template-editor__close" @click="showTemplateEditor = false">
                        <div class="template-editor__close-img"></div>
                    </div>
                </div>
            </div>
            <CopyrightBar />
        </div>
        <div v-else class="right-content">
            <!-- 助手选择 -->
            <div class="msg-box-flex-wrapper">
                <MsgBoxScroll>
                    <MsgWelcome v-model="WELCOME_MODELS" />
                    <div class="model-list">
                        <div class="model-list-title">
                            <span>助手列表</span>
<!--                            <span class="assistant-manage" @click="toMemFrontend">应用中心</span>-->
                        </div>
                        <template v-for="item in modelList">
                            <el-tag v-if="(item.category === '业务模型' && !item.noShowInModel) || item.category === '助手列表'" :key="item.value" class="model-tag" :class="{'selected': currentModel === item}"
                                :type="item && item.promptTemplateList && item.promptTemplateList.length ? 'primary' : 'info'"
                                @click.stop="currentModel = item">{{ item.title }}</el-tag>
                        </template>
                    </div>
                    <div v-if="currentModel" class="model-info">
                        <div class="model-info-title">
                            {{currentModel.title}}
                            &nbsp;&nbsp;
                            <!-- <el-link :underline="false" @click.stop="showModelSetting(currentModel)"><i class="el-icon-s-tools"></i>参数</el-link> -->
                        </div>
                        <el-row :gutter="24">
                        <el-col :span="8" v-for="item in currentModel.promptTemplateList" :key="item.id">
                            <div class="prompt-template">
                                <div class="prompt-template-title">
                                    {{ item.name }}
                                </div>
                                <pre class="description">{{ item.content }}</pre>
                                <div class="setting">
                                    <el-link :underline="false" @click.stop="currentTemplate = item; newChat('');"><i class="el-icon-tickets"></i>模板编辑</el-link>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    </div>
                </MsgBoxScroll>
            </div>
            <CopyrightBar />
        </div>
        <gpt-shortcuts v-if="!currentTemplate" :isCall="false"/>
        <ModelSettingDrawer ref="modelSettingDrawer" @changeModelSetting="$emit('changeModelSetting')"></ModelSettingDrawer>
    </div>
</template>

<script>
import historyAPI from '@/api/history.api.js';
import modelAPI from '@/api/model.api.js';

import CommonAskMixin from '@/app/mixins/CommonAskMixin.js';
import ChatSocketMixin from '@/app/mixins/ChatSocketMixin.js';
import SseMixin from '@/app/mixins/SseMixin.js';

import { timeToString } from '@/utils/time.js';

import { WELCOME_MODELS } from '@/app/constant/WELCOME.js';

import CopyrightBar from '@/app/components/ui/CopyrightBar.vue';
import LeftMenu from '@/app/components/ui/LeftMenu.vue';
import MsgBoxScroll from '@/app/components/ui/MsgBoxScroll.vue';
import MsgWelcome from '@/app/components/chatMsg/MsgWelcome.vue';
import MsgWelcomePrompt from '@/app/components/chatMsg/MsgWelcomePrompt.vue';
import MsgUserAsk from '@/app/components/chatMsg/MsgUserAsk.vue';
import MsgChatRespond from '@/app/components/chatMsg/MsgChatRespond.vue';
import MsgChatRespondThink from '@/app/components/chatMsg/MsgChatRespondThink.vue';
import MsgKnowledgeFileSelect from '@/app/components/chatMsg/MsgKnowledgeFileSelect.vue';
import ExportSessionBox from '@/app/components/ui/ExportSessionBox.vue';

import ModelSettingDrawer from '@/app/components/ui/ModelSettingDrawer.vue';

export default {
    name: 'call',
    components: {
        CopyrightBar,
        LeftMenu,
        MsgBoxScroll,
        MsgWelcome,
        MsgWelcomePrompt,
        MsgUserAsk,
        MsgChatRespond,
        MsgChatRespondThink,
        MsgKnowledgeFileSelect,
        ModelSettingDrawer,
        ExportSessionBox
    },
    mixins: [CommonAskMixin, ChatSocketMixin, SseMixin],
    data () {
        return {
            socket: null,
            prompt: '', // 当前输入内容
            model: 'commonMode', // 当前使用哪个模型
            ui: {
                isSocketReconnecting: false, // 是否正在连接socket
                isLoadingHistory: true, // 正在加载总历史列表
                isLoadingChat: false, // 正在加载当前聊天的历史记录
                typing: false, // 是否在输入中
                recording: false, // 是否在录音中
                showLeftMenu: true
            },
            currentChat: {
                title: '',
                sessionId: '',
                messages: [],
                updateTime: 0
            },
            currentSessionId: '',
            historyMap: {},
            mdTempStr: '',
            WELCOME_MODELS,
            currentModel: null,
            currentTemplate: null,
            templateValueMap: null,
            showModelSettings: false,
            showTemplateValueMap: false,
            showTemplateEditor: true,
            showExportSession: false,
            isAutoReconnect: true
        };
    },
    provide () {
        return {
            loadChat: this.loadChat,
            deleteChat: this.deleteChat,
            editTitle: this.editTitle,
            currentSessionId: () => this.currentSessionId,
            stopGenerating: this.stopGenerating,
            starSession: this.starSession
        };
    },
    computed: {
        useLLM () {
            return this.$store.state.appSettings.useLLM;
        },
        modelList () {
            return this.$store.state.appSettings.modelList;
        },
        modelListCommon () {
            let modelList = this.$store.state.appSettings.modelList;
            let commonMode = modelList.find(item => item.value === 'commonMode');
            if (commonMode) {
                return [commonMode];
            } else {
                return [];
            }
        },
        allSession () {
            let all = [];
            for (const sessionId in this.historyMap) {
                const session = this.historyMap[sessionId];
                if (!session['temporary']) all.push(session);
            }
            all.sort((a, b) => b.createdTimeStamp - a.createdTimeStamp);
            return all;
        }
    },
    async mounted () {
        await this.$store.dispatch('appSettings/initModelList');

        await this.loadHistory(); // 加载历史对话
    },
    methods: {
        goto (path) {
            this.$router.push(path);
        },

        /**
        * 加载会话
        */
        async loadChat (sessionId) {
            if (this.ui.typing) return;
            if (!this.historyMap[sessionId]) return;
            if (this.ui.isLoadingChat) return;
            this.ui.isLoadingChat = true;
            localStorage.setItem('currentSessionId', sessionId);
            this.currentSessionId = sessionId;
            Object.assign(this.currentChat, this.historyMap[sessionId]);
            this.currentChat.messages = [];
            let result = await historyAPI.getChatHistory(sessionId);

            for (const context of result.data) {
                const { askObj, answerObj } = JSON.parse(context.externalInfo);
                answerObj['feedback'] = context.likeOrNot;
                answerObj['questionId'] = context.questionId;
                answerObj['finished'] = true;
                this.currentChat.messages.unshift(answerObj);
                this.currentChat.messages.unshift(askObj);
            }
            this.ui.isLoadingChat = false;

            // 如果是知识库问答则加载相关知识库
            let session = this.historyMap[sessionId];
            this.currentModel = null;
            this.currentTemplate = null;
            if (session && session.modelCode && session.promptTemplateCode) {
                let { modelCode, promptTemplateCode } = session;
                this.currentModel = this.modelList.find((item) => {
                    return item.value === modelCode;
                });
                let ret = await modelAPI.getPromptTemplateByCode(promptTemplateCode);
                this.currentTemplate = ret.data;
            }

            // 初始化socket（根据sessionId）
            // this.initSocket();
        },

        /**
        * 加载总历史列表
        */
        async loadHistory () {
            this.ui.isLoadingHistory = true;
            let result = await historyAPI.getHistoryList();

            result.data.forEach(element => {
                element['createdTimeStamp'] = Date.parse(element.createTime);
                this.$set(this.historyMap, element.sessionId, element);
            });
            this.ui.isLoadingHistory = false;
        },

        showModelSetting (item) {
            this.$refs.modelSettingDrawer.open(item);
        },

        /**
        * 创建新聊天
        */
        async newChat () {
            if (this.ui.typing) return;
            if (this.ui.isLoadingChat) return;
            if (!this.currentModel || !this.currentTemplate) return;
            this.ui.isLoadingChat = true;

            let result = await historyAPI.getNewSessionId();
            // 创建时先不保存数据
            this.currentSessionId = result.data;
            this.currentChat = {
                collected: 0,
                title: '',
                sessionId: result.data,
                modelCode: this.currentModel.value,
                promptTemplateCode: this.currentTemplate.code,
                messages: [],
                createdTimeStamp: Date.now()
            };

            // 保存
            // localStorage.setItem('currentSessionId', this.currentSessionId);
            await this.saveChat('');

            // 初始化socket（根据sessionId）
            // this.initSocket();

            this.ui.isLoadingChat = false;
            this.showTemplateValueMap = true;
        },

        /**
        * 保存会话
        */
        async saveChat (title) {
            let payload = {
                collected: 0,
                createTime: timeToString(Date.now()),
                createdTimeStamp: Date.now(),
                sessionId: this.currentSessionId,
                modelCode: this.currentModel.value,
                promptTemplateCode: this.currentTemplate.code,
                title: title.toString()
            };
            if (this.currentKnowledge) { // 知识库对话
                payload.knowledgeId = this.currentKnowledge.knowledgeId;
                payload.knowledgeName = this.currentKnowledge.knowledgeName;
            }
            this.$set(this.historyMap, this.currentSessionId, payload);
            await historyAPI.saveSession(payload);
        },

        /**
        * 保存会话
        */
        async saveContext (isInvalid) {
            let askObj = this.currentChat.messages[this.currentChat.messages.length - 2];
            let answerObj = this.currentChat.messages[this.currentChat.messages.length - 1];
            answerObj['askContent'] = askObj.content;
            let extInfo = JSON.stringify({ askObj, answerObj });
            let question = askObj.notShowContent ? askObj.notShowContent + `Question:${askObj.content}` : askObj.content;
            let payload = {
                'answer': answerObj.content,
                'questionTime': timeToString(askObj.questionTime || Date.now()), // 提问时间
                'createTime': timeToString(Date.now()), // 回答时间
                'externalInfo': extInfo,
                'isInvalidAnswer': isInvalid ? 1 : 0,
                'likeOrNot': 0,
                'question': question,
                'sessionId': this.currentSessionId,
                'useModel': this.useLLM
            };
            let result = await historyAPI.saveOneContext(payload);
            answerObj['questionId'] = result.data;
        },

        /**
        * 修改会话标题
        */
        async editTitle (sessionId, title) {
            if (!this.historyMap[sessionId]) return;
            let payload = { sessionId, title };
            await historyAPI.editTitle(payload);
            this.historyMap[sessionId].title = title;
        },

        /**
        * 星级会话
        */
        async starSession (sessionId, collected) {
            this.historyMap[sessionId].collected = collected;
            let payload = { sessionId, collected };
            await historyAPI.starSession(payload);
        },

        /**
        * 停止生成
        */
        async stopGenerating () {
            if (!this.ui.typing) return;
            let payload = { sessionId: this.currentSessionId };
            await historyAPI.stopAnswer(payload);

            this.closeSocket();

            let last = this.currentChat.messages[this.currentChat.messages.length - 1];
            // 打字完成
            this.ui.typing = false;
            if (last && last.role === 'assistant') this.$set(last, 'finished', true);
            this.saveContext(true);
        },

        /**
        * 清空会话
        */
        clearChat () {
            this.currentChat = {
                title: null,
                prompt: '',
                messages: []
            };
        },

        /**
        * 删除当前会话
        */
        async deleteChat (sessionId) {
            if (this.currentChat.sessionId === sessionId) {
                let current = this.currentChat;
                let next = null;
                let idx = this.allSession.findIndex((item) => {
                    return item.sessionId === sessionId;
                });
                for (let i = idx + 1; i < this.allSession.length; i++) {
                    let item = this.allSession[i];
                    if (current.sessionId === item.sessionId) {
                        continue;
                    } else if (current.knowledgeId && item.knowledgeId) {
                        next = item;
                        break;
                    } else if (!current.knowledgeId && !item.knowledgeId) {
                        next = item;
                        break;
                    }
                }
                if (!next) {
                    for (let i = 0; i < this.allSession.length; i++) {
                        let item = this.allSession[i];
                        if (current.sessionId === item.sessionId) {
                            continue;
                        } else if (current.knowledgeId && item.knowledgeId) {
                            next = item;
                            break;
                        } else if (!current.knowledgeId && !item.knowledgeId) {
                            next = item;
                            break;
                        }
                    }
                }
                if (!next) {
                    this.newChat(true);
                } else {
                    this.loadChat(next.sessionId);
                }
            }
            this.$delete(this.historyMap, sessionId);
            let payload = { sessionId };
            await historyAPI.deleteSession(payload);
        },

        /**
         * 普通对话提问
         */
        templateAsk (data) {
            if (this.ui.typing) return;
            let prompt = data.input;
            let code = this.currentTemplate.code;
            let templateValueMap = this.templateValueMap || {};
            let useLLM = this.useLLM;
            this.prompt = '';
            this.addAsk(prompt);

            let modelSettings = this.currentModel.modelSettings || {};
            let { contextLimit, temperature, maxLength } = modelSettings;

            // 文字提问
            // let msg = {
            //     'code': code,
            //     'templateValueMap': templateValueMap,
            //     'question': prompt,
            //     'useLLM': useLLM,
            //     'type': 'TEXT',
            //     contextLimit,
            //     temperature,
            //     maxLength
            // };
            // this.socket.send(msg);
            let sseMsg = {
                'templateCode': code,
                'templateValueMap': templateValueMap,
                'message': prompt,
                'model': useLLM,
                contextLimit: contextLimit,
                temperature: temperature,
                maxTokens: maxLength
            };
            // 开始等待打字
            this.ui.typing = true;
            this.currentChat.messages.push({ role: 'assistant', content: '', feedback: null, finished: false });
            // this.socket.send(msg);
            this.sendSseStream(sseMsg);

            this.showTemplateValueMap = false;
        }
    }
};
</script>
<style scoped lang="scss">
.loading-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 120;
    backdrop-filter: blur(20px);
    background-color: rgba(41, 105, 255, 0.2);
}

.models-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    // background: linear-gradient(137deg, #fff 0%, rgb(219, 230, 255) 100%);

    .right-content {
        position: relative;
        height: 100%;
        flex: 1 1 auto;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
        justify-content: space-between;
        background: var(--page-bg-img);
        background-size: cover;

        .template-flex-wrapper {
            position: relative;
            width: 100%;
            height: 100%;
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .template-flex-wrapper-top {
            position: relative;
            width: 100%;
            height: 64px;
            border-bottom: 1px solid var( --shortcuts-border);
            background-color: var(--msg-welcome-prompt-bg);
            flex: 1 1 auto;
            display: flex;
            align-items: center;
            padding: 0 1em;
            ::v-deep{
                .el-link--inner{
                    height: 24px;
                    display: flex;
                    align-items: center;
                    >img{
                        margin-right: 8px;
                    }
                    >span{
                        color: var(--ai-model-classification-font);
                    }
                }
            }
            .iconfile{
                font-size: 24px;
            }
        }
        .template-flex-wrapper-main {
            position: relative;
            width: 100%;
            height: calc(100% - 64px);
            flex: 1 1 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .template-flex-wrapper-left,
        .template-flex-wrapper-right {
            position: relative;
            width: 50%;
            height: 100%;
            flex: 1 1 auto;
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            justify-content: space-between;
        }

        .template-flex-wrapper-right {
            border-left: 1px solid var(--shortcuts-border);
        }

        .msg-box-flex-wrapper {
            flex: 1 1 auto;
            width: 100%;
            overflow: hidden;
        }

        .input-box-flex-wrapper {
            flex: 0 0 auto;
            width: 100%;
            max-width: 1000px;
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;

            .input-placeholder {
                flex: 0 0 58px;
            }

            .gpt-chatbox {
                &.typing {
                    pointer-events: none;
                    opacity: 0.6;
                }
            }
        }
    }

    .el-loading-mask {
        z-index: 99;
    }

    .model-list {
        .model-list-title {
            font-size: 1.5em;
            font-weight: 500;
            font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
            margin: 0.5em;
            display: flex;
            justify-content: space-between;
            .assistant-manage {
                font-size: 14px;
                color: #209BFF;
                cursor: pointer;
                text-decoration: underline;
            }
        }
        .model-tag {
            margin: 0.5em;
            cursor: pointer;
            &.selected {
                background: #126cff;
                color: white;
            }
        }
    }
    .model-info {
        margin-top: 3em;
        .model-info-title {
            font-size: 1.2em;
            font-weight: 500;
            font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
            margin: 0.5em;
        }
        .prompt-template {
            position: relative;
            width: 100%;
            height: 175px;
            background-image: var(--ai-model-card);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            padding: 12px;
            margin-bottom: 8px;

            .prompt-template-title {
                width: 100%;
                height: 24px;
                font-size: 16px;
                font-weight: 500;
                font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
                color: var(--font-color);
                line-height: 24px;
                overflow: hidden;
            }

            .description {
                font-size: 14px;
                color: var(--ai-description-text);
                line-height: 20px;
                margin-top: 8px;
                height: 100px;
                overflow: hidden;
            }
            .setting {
                position: absolute;
                bottom: 12px;
                right: 20px;
                font-size: 14px;
                i {
                    padding-right: 2px;
                }
                &:hover {
                    color: var(--ai-model-classification-font);
                }
            }
        }
    }

    .viewer-editor {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .template-editor__open {
        position: absolute;
        right:0;
        top: 45%;
        width: 20px;
        height: 80px;
        right: 0;
        z-index: 10;
        cursor: pointer;

        .template-editor__open-img {
            width: 20px;
            height: 80px;
            background-repeat: no-repeat;
            background-size: contain;
            background-image: var(--shortcuts-open-img);
        }
    }
    .template-editor__close {
        position: absolute;
        left:0;
        top: 45%;
        width: 20px;
        height: 80px;
        right: 0;
        z-index: 10;
        cursor: pointer;

        .template-editor__close-img {
            width: 100%;
            height: 100%;
            background: var(--right-close-img);
            transform: translateX(-20px);
        }
    }

    .float-buttons {
        position: absolute;
        bottom: 130px;
        left: 1em;
        width: fit-content;
        height: fit-content;
        z-index: 20;
        &.right {
            left: unset;
            right: 1em;
        }
    }
    .gpt-editor-templateValueMap, .gpt-editor-modelSettings {
        position: absolute;
        bottom: 150px;
        left: 1em;
        width: calc(50% - 1.5em);
        height: fit-content;
        z-index: 10;
        border: 1px solid var(--shortcuts-border);
        border-radius: 0.5em;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
        &.gpt-editor-modelSettings {
            left: unset;
            right: 1em;
        }
    }
}
</style>
